module.exports = __webpack_public_path__ + "static/media/eye-simple.7f50156c.svg";